import CandidatureAddRequest, {
  CandidatureAddRequestBody,
} from "./candidature-add.request";

const createBody = (
  request: CandidatureAddRequest,
): CandidatureAddRequestBody => {
  return {
    candidateEntries: request.candidatureEntries,
    driverId: request.driverId,
    acceptImmediately: request.acceptImmediately,
  };
};

const candidatureAddRequestFactory = {
  createBody,
};

export default candidatureAddRequestFactory;
